<template lang="pug">
v-container.fill-height.justify-center(fluid :class="containerClasses")
    SetNewPassword(v-if="recoveryCode" :recoveryCode="recoveryCode")
    RecoveryRequestForm(v-if="!recoveryCode")

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import RecoveryRequestForm from '@/components/password-recovery/RecoveryRequestForm.vue'
import SetNewPassword from '@/components/password-recovery/SetNewPassword.vue'

@Component({
  components: {
    RecoveryRequestForm,
    SetNewPassword
  }
})
export default class PasswordRecoveryPage extends Vue {
  @Prop() recoveryCode!: string

  get containerClasses(): string {
    if (this.$vuetify.breakpoint.smAndDown) {
      return 'pa-0 align-start'
    }

    return ''
  }
}
</script>

<style lang="stylus" scoped>

</style>
